import { RESET_ELASTICSEARCH_TEST_CONFIG, SET_ELASTICSEARCH_ENABLED, SET_ELASTICSEARCH_TEST_CONFIG, TOGGLE_ELASTICSEARCH_TEST_CONFIG } from "../actions/elasticSearchActions";
import { loadTestConfigFromStorage } from "../utils/elasticSearchStorage";

export const initialState = {
  elasticSearchEnabled: false,
  // eslint-disable-next-line eqeqeq
  elasticSearchAllowed: process.env.REACT_APP_ELASTIC_SEARCH_ALLOWED == "true",
  testConfig: {
    explain: false,
    searchTermBoost: 1,
    searchFields: [],
    minScore: 0.1,
    distanceScore: {
      decayFunctionType: "gauss", // | 'exp' | 'gauss';
      scale: "1km",
      offset: "200m",
      decay: 0.5,
      boost: 1,
    },
  },
  testConfigEnabled: false,
};

// Load saved config from localStorage and merge with initial state
const getInitialStateWithStorage = () => {
  const { testConfig: savedTestConfig, testConfigEnabled: savedTestConfigEnabled } = loadTestConfigFromStorage();

  return {
    ...initialState,
    testConfig: savedTestConfig ? { ...initialState.testConfig, ...savedTestConfig } : initialState.testConfig,
    testConfigEnabled: savedTestConfigEnabled,
  };
};

const elasticSearchReducer = (state = getInitialStateWithStorage(), action) => {
  switch (action.type) {
    case SET_ELASTICSEARCH_ENABLED:
      if (state.elasticSearchAllowed) {
        return { ...state, elasticSearchEnabled: action.payload };
      } else {
        return { ...state, elasticSearchEnabled: false };
      }
    case SET_ELASTICSEARCH_TEST_CONFIG:
      return {
        ...state,
        testConfig: action.payload,
      };
    case RESET_ELASTICSEARCH_TEST_CONFIG:
      return {
        ...state,
        testConfig: initialState.testConfig,
      };
    case TOGGLE_ELASTICSEARCH_TEST_CONFIG:
      return {
        ...state,
        testConfigEnabled: action.payload,
      };
    default:
      return state;
  }
};

export default elasticSearchReducer;
